import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { clearContentCache } from "@/lib/useContent";
import { formatApiError } from "@/context/AuthContext";
import {
    Save, RotateCcw, Plus, Trash2, Edit3, Check, X,
    FileText, Film, BookOpen, MapPin, Inbox, Image as ImageIcon, Upload, Navigation, UserCheck, Radio, CalendarClock, Ban, MessageSquareQuote, Star, Mic, Play,
} from "lucide-react";
import { Field } from "../shared.jsx";

export default function SubmissionsModerator() {
    const [items, setItems] = useState([]);
    const load = () => api.get("/admin/submissions").then((r) => setItems(r.data));
    useEffect(() => { load(); }, []);

    const approve = async (id) => {
        try {
            await api.post(`/admin/submissions/${id}/approve`);
            toast.success("Approved.");
            load();
        } catch (e) {
            toast.error(formatApiError(e.response?.data?.detail));
        }
    };

    const remove = async (id) => {
        if (!window.confirm("Delete this submission?")) return;
        try {
            await api.delete(`/admin/submissions/${id}`);
            toast.success("Deleted.");
            load();
        } catch (e) {
            toast.error(formatApiError(e.response?.data?.detail));
        }
    };

    return (
        <div data-testid="submissions-editor" className="space-y-3">
            {items.length === 0 && <div className="card p-8 text-center text-[var(--sb-text-dim)]">No subscriber submissions yet.</div>}
            {items.map((s) => (
                <div key={s.id} className="card p-5 flex justify-between gap-4">
                    <div>
                        <div className="overline">{s.user_name} · {s.location}</div>
                        <div className="font-serif text-lg">{s.title}</div>
                        <a href={s.video_url} target="_blank" rel="noreferrer" className="text-sm text-[var(--sb-brand)] hover:text-[var(--sb-text)] block mt-1">{s.video_url}</a>
                        {s.note && <p className="text-sm text-[var(--sb-text-dim)] mt-2">{s.note}</p>}
                    </div>
                    <div className="flex flex-col gap-2 shrink-0">
                        {!s.approved && (
                            <button onClick={() => approve(s.id)} className="btn-primary text-xs" style={{padding: "0.4rem 0.8rem"}}>
                                <Check size={12} /> Approve
                            </button>
                        )}
                        {s.approved && <span className="text-xs uppercase tracking-wider text-[var(--sb-brand)] text-center py-2">Live</span>}
                        <button onClick={() => remove(s.id)} className="text-[var(--sb-text-dim)] hover:text-red-400 p-1 self-end"><Trash2 size={16} /></button>
                    </div>
                </div>
            ))}
        </div>
    );
}

/* -------------------------------------------------------------------------- */
/* Subscribers manager — manual grant/revoke for PayPal payments              */
